<template>
	<div class="bodily">
		<div class="insert-title">{{$t('open.t3')}}</div>
		
		<el-form
			:model="formData"
			:rules="rules"
			inline
			ref="bodily"
		>
			<el-row :gutter="16">
				<el-col :span="12">
					<el-form-item
						:label="$t('open.t30')"
						label-width="80px"
						prop="height"
					>
						<el-input
							v-model.trim.number="formData.height"
							placeholder="请输入身高"
						>
						<template slot="append">cm</template>
						</el-input>
						
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item
						:label="$t('open.t31')"
						label-width="80px"
						prop="weight"
					>
						<el-input
							v-model.trim.number="formData.weight"
							placeholder="请输入体重"
						>
						<template slot="append">kg</template>
						</el-input>
						
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item
						:label="$t('open.t32')"
						label-width="80px"
						prop="waist"
					>
						<el-input
							type="number"
							v-model.trim.number="formData.waist"
							placeholder="请输入腰围(选填)"
						>
						<template slot="append">cm</template>
						</el-input>
						
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item
						:label="$t('open.t33')"
						label-width="80px"
						prop="hip"
					>
						<el-input
							type="number"
							v-model.trim.number="formData.hip"
							placeholder="请输入臀围(选填)"
						>
						<template slot="append">cm</template>
						</el-input>
						
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div class="footer-btn">
			<el-button @click="handlePrev" class="prev qjc-fts-16 qjc-block">{{$t('open.t12')}}</el-button>
			<el-button @click="next" :loading="submiting" class="next qjc-fts-16 qjc-block">{{$t('open.t61')}}</el-button>
		</div>
	</div>
</template>

<script>
	import { packageOpen } from '@/utils/axios'
	import { Base64 } from 'js-base64'
	
	let numberInput = function (value) {
		var price = '' + value;
		price = price
		    .replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
		    .replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
		    .replace('.', '$#$')
		    .replace(/\./g, '')
		    .replace('$#$', '.')
		    .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只能输入两个小数
		if (price.indexOf('.') < 0 && price != '') {
		    // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
		    price = parseFloat(price);
		}
		return price
	}
	export default{
		name: "bodily",
		data() {
			var heightVerify = (rule, value, callback) => {
				if(isNaN(numberInput(value)) || numberInput(value) < 130 || numberInput(value) > 200){
					callback(new Error('身高为130~200'));
				}else{
					callback();
				}
			}
			var weightVerify = (rule, value, callback) => {
				if(isNaN(numberInput(value)) || numberInput(value) < 30 || numberInput(value) > 160){
					callback(new Error('体重为30~160'));
				}else{
					callback();
				}
			}

			var waistVerify = (rule, value, callback) => {
				if(numberInput(value) == '') {
					this.formData.waist = ''
				}
				if(numberInput(value) != '' && (numberInput(value) < 40 || numberInput(value) > 150)){
					callback(new Error('腰围为40~150'));
				}else{
					callback();
				}
				
			}
			var hipVerify = (rule, value, callback) => {
				if(numberInput(value) == '') {
					this.formData.hip = ''
				}
				if(numberInput(value) != '' && (numberInput(value) < 60 || numberInput(value) > 150)){
					callback(new Error('臀围为60~165'));
				}else{
					callback();
				}
			}
			
			return {
				rules: {
					height: [
						{ required: true, message: '请填写您的身高1111', trigger: 'blur' },
						{ validator: heightVerify, trigger: 'blur' }
					],
					weight: [
						{ required: true, message: '请填写您的体重', trigger: 'blur' },
						{ validator: weightVerify, trigger: 'blur' }
					],
					// chest: [
					// 	{ required: true, message: '请填写您的胸围', trigger: 'blur' },
					// 	{ validator: chestVerify, trigger: 'blur' }
					// ],
					waist: [
						{ required: false, message: '请填写您的腰围', trigger: 'blur' },
						{ validator: waistVerify, trigger: 'blur' }
					],
					hip: [
						{ required: false, message: '请填写您的臀围', trigger: 'blur' },
						{ validator: hipVerify, trigger: 'blur' }
					]
				},
				hasFb: false,
				submiting: false,
			}
		},
		props: ['formData', 'clearData', 'type'],
		inject: ['handleRefresh'],
		mounted() {
			if(this.formData.package == '6') {
				this.hasFb = true
			}
		},
		methods: {
			//下一步
			next() {
				this.submiting = true;
				this.$refs.bodily.validate((isSuc, err) => {
					if(isSuc){
						const formData = JSON.parse(JSON.stringify(this.formData))
						if(formData.package == '6') {
							delete formData.disease
							delete formData.famdis
							delete formData.fat
							delete formData.habeat
							delete formData.habsport
							delete formData.smoke
							delete formData.drink
							delete formData.sleep
							delete formData.vege
							delete formData.oper
							delete formData.examdate
							delete formData.examplace
							
							delete formData.prebust
							delete formData.prefat
							delete formData.prewaist
							delete formData.predis2
							delete formData.preweek
							delete formData.preweight
							delete formData.prehip
							delete formData.week
							delete formData.aps1
							delete formData.bsex
							delete formData.bweight
							delete formData.mage
							delete formData.dbp
							delete formData.sbp
							
							delete formData.examine
							delete formData.sbpCombo
						}
						if(this.type == 'update') {
							formData.act = 'update'
						}
						formData.goods_id = formData.package
						formData.disease = [...formData.fbdisease]
						delete formData.fbdisease
						delete formData.package
						formData.operator = localStorage.getItem('mobile');
						formData.birth = formData.birth.split('/').join('')
						
						const goods_type = formData.goods_type
						delete formData.goods_type
						packageOpen(formData).then(res => {
							this.submiting = false;
							
							if(res.code == 200){
								// this.updateShow = false;
								const {id} = JSON.parse(Base64.decode(res.data))
								this.download(goods_type,id)
								this.clearData();
								this.$emit('checkTab', 'Personal');
								this.handleRefresh();
								
							}else{
								// this.updateShow = false;
								this.$myAlert({
									type: 'fail',
									content: res.msg
								});
							}
						});
						
					} else {
						this.submiting = false;
					}
				});
			},
			download (type, id) {
			  if (type == 'AIMB') {// 母婴
			    window.open("/muying/report/lookReport.html?type=download&id=" + id);
			    return
			  } else if (type == 'AIZH') {
			    window.open('/kyzc/lookReport.html?id=' + id);
			
			    return
			  } else if (type == 'AIFB') {
			    window.open('/fb/lookReport.html?id=' + id);
			
			    return
			  } else if (type == 'AIBG') {
			    window.open('/baijin/lookReport.html?id=' + id);
			
			    return
			  } else if (type == 'M22') {
			    window.open('/m22/lookReport.html?id=' + id);
			
			    return
			  } else {
			    let openUrl = this.$router.resolve({
			      path: "/reportPrint/lookReport",
			      query: {
			        id: id
			      }
			    });
			    window.open(openUrl.href);
			  }
			
			},
			handlePrev() {
				this.$emit('checkTab','FbQuestions');
			},
		}
	}
</script>

<style scoped>
	.bodily >>> .el-form-item__label{
		font-size: 14px;
		color: #777F8F;
		padding-right: 10px;
		text-align: right;
	}
	
	
	.bodily >>> .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
		display: none;
	}
	
	
	.el-row >>> .el-form-item__content{
		width: 100%;
	}
	
	.el-row >>> .el-input,.el-select{
		width: 100%;
	}
	
</style>
<style lang="scss" scoped>
	.bodily{
		padding-top: 50px;
		
		.insert-title {
			position: relative;
			font-size: 16px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #293033;
			line-height: 16px;
			padding-bottom: 15px;
			border-bottom: 1px solid #E5E8F5;
			margin-bottom: 32px;
			
			&::before{
				position: absolute;
				left: -24px;
				top: 0;
				content: '';
				width: 4px;
				height: 20px;
				background-color: #6883FB;
			}
		}
		
		.el-form-item{
			width: 100%;
		}
		
		.next-form-item {
			margin-right: 0 !important;
		}
		.footer-btn {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 40px;
		}
				
		.next{
			width: 96px;
			height: 34px;
			border-radius: 17px;
			border: none;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #fff;
		}
		.prev {
			width: 96px;
			height: 34px;
			border-radius: 17px;
			border: 1px solid #6883FB;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #6883FB;
			background-color: #fff;
			margin-right: 24px;
		}
	}
</style>
